// extracted by mini-css-extract-plugin
module.exports = {"base":"Hamburger-module-base","element":"Hamburger-module-element","crossed":"Hamburger-module-crossed"};